<template>
  <div class="ibox-content">
    <modal-form modal-id="add-placement">
      <div slot="title">Place a link</div>
      <div slot="form" v-if="modalPbn">
        <div class="row">
          <div class="col-lg-2">Url</div>
          <div class="col-lg-10">
            <button class="btn btn-primary btn-xs pull-right m-l-xs" @click="adminLogin"><i class="fas fa-user-lock"></i> Admin Login</button>
            <button class="btn btn-danger btn-xs pull-right" @click="reportLoginIssue(modalPbn)"><i class="fa fa-warning"></i> Login issue</button>
            <a :href="'https://' + modalPbn.domain + '/wp-admin'" target="_blank">{{ shorten(modalPbn.domain) }}/wp-admin <i class="fa fa-external-link"></i></a>
          </div>
        </div>
        <div class="row" v-for="(login, i) in modalPbn.logins" :key="'logins-' + i">
          <div class="col-lg-2">Username</div>
          <div class="col-lg-10"><a @click="copyToClipboard(login.username)">{{ login.username }} <i class="fa fa-copy"></i></a></div>
          <div class="col-lg-2">Password</div>
          <div class="col-lg-10"><a @click="copyToClipboard(login.password)">{{ login.password }} <i class="fa fa-copy"></i></a></div>
        </div>
        <hr>
        <div class="row m-b-sm">
          <div class="col-lg-3">
            Link
            <a @click="copyToClipboard(placementData['link'].url)"><i class="fa fa-copy btn pull-right"></i></a>
          </div>
          <div class="col-lg-9">
            <v-select :options="order.pendingTargets"  label="url" v-model="placementData['link']" @input="updateAnchor"></v-select>
          </div>
        </div>
        <div class="row m-b-sm">
          <div class="col-lg-3">
            Url
            <a @click="copyToClipboard(placementData['url'])"><i class="btn fa fa-copy pull-right"></i></a>
          </div>
          <div class="col-lg-9">
            <input type="text" class="form-control" v-model="placementData['url']">
          </div>
        </div>
        <div class="row  m-b-sm">
          <div class="col-lg-3">
            Anchor
            <a @click="copyToClipboard(placementData['anchor'])"><i class="btn fa fa-copy pull-right"></i></a>
          </div>
          <div class="col-lg-9">
            <input type="text" class="form-control" v-model="placementData['anchor']">
          </div>
        </div>
      </div>
      <div slot="footer">
        <button class="btn btn-sm btn-primary" @click="addPlacement">Save</button>
      </div>
    </modal-form>
    <div class="row" v-if="pbnMeta.count">
      <div class="col-lg-12">
        <h4>{{ pbnMeta.count }} pbns available</h4>
      </div>
    </div>
    <div class="row m-b-sm" v-if="pbnMeta.filters && pbnMeta.filters.clients">
      Clients:
      <span class="label label-primary m-r-xs" v-for="client in pbnMeta.filters.clients" :key="client.id">
        {{ client.name }}
      </span>
    </div>
    <div class="row m-b-sm" v-if="pbnMeta.filters && pbnMeta.filters.groups">
      Groups:
      <span class="label label-success m-r-xs" v-for="group in pbnMeta.filters.groups" :key="group.id">
        {{ group.name }}
      </span>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <table class="table table-striped table-bordered table-hover">
          <thead>
          <tr>
            <th>Pbn</th>
            <th>Languages</th>
            <th>Client</th>
            <th>Group</th>
            <th>Articles</th>
            <th>Grade</th>
            <th>Stats</th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="pbn in pbns" :key="pbn.id">
            <td>
              <router-link :to="{ path: '/pbn/' + pbn.punyDomain }">{{ pbn.domain }}</router-link>
              <a :href="'http://' + pbn.domain" target="_blank"><i class="fa fa-external-link"></i></a>
            </td>
            <td>{{ pbn.language.join(', ') }}</td>
            <td>{{ pbn.client ? pbn.client.name : '?!' }}</td>
            <td>{{ pbn.group ? pbn.group.name : '/' }}</td>
            <td>{{ pbn.content.posts || '?' }} | {{ pbn.content.pages || '?' }}</td>
            <td>{{ pbn.stats && pbn.stats.grade && pbn.stats.grade.grade ? pbn.stats.grade.grade.desc : '/' }}</td>
            <td>Stats</td>
            <td>
              <i class="fas fa-warning red" v-if="!pbn.linkBuildSafe" v-tooltip="'This pbn has been deployed recently'"></i>
              <a @click="placementOpen(pbn)"><i class="fa fa-map-pin"></i></a>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import ModalForm from '../../../../../Helpers/Modal/Form'
import { Browser, String } from '../../../../../../mixins/helperMixin'

export default {
  data () {
    return {
      pbns: [],
      pbnMeta: {},
      modalPbn: null,
      placementData: {}
    }
  },
  mixins: [Browser, String],
  components: {
    modalForm: ModalForm
  },
  computed: {
    ourHosting () {
      return (this.modalPbn.integrations && this.modalPbn.integrations.hosting && this.modalPbn.integrations.hosting.hostingType === 'CUSTOM_HOST') ||
        (this.modalPbn.hosting && this.modalPbn.hosting.id === '5f913275ced39178dcb06028') ||
        this.modalPbn.hasAphexManager
    },
    ...mapGetters({
      order: 'getLinkOrder'
    })
  },
  mounted () {
    this.getPbns()
  },
  methods: {
    placementOpen (pbn) {
      this.modalPbn = pbn
      this.placementData = {
        pbn: pbn.id,
        order: this.order.id
      }
      $('#add-placement').modal('show')
    },
    async getPbns () {
      try {
        let r = await axios.get('/pbn/links/order/' + this.order.id + '/search-pbns?limit=10000')
        this.pbns = r.data.data
        this.pbnsMeta = r.data.meta
      } catch (e) {
        this.$toastr.error(e, 'Error!')
      }
    },
    addPlacement () {
      if (!this.placementData.link) {
        this.$toastr.error('Please select a link')
        return
      }

      if (!this.placementData.url) {
        this.$toastr.error('Please provide placement url')
        return
      }

      axios.post('/pbn/links/order/' + this.order.id + '/placement', this.placementData)
        .then(r => {
          this.getPbns()
          this.$toastr.success('Placement added successfully!', 'Very good!')
          this.placementData = {}
          this.$store.dispatch('loadLinkOrder', this.order.id)
          $('#add-placement').modal('hide')
        })
        .catch(e => {
          this.$toastr.error(e, 'Unable to add placement!')
        })
    },
    updateAnchor (e) {
      this.placementData.anchor = e.anchor
    },
    reportLoginIssue (pbn) {
      if (!confirm('Report login issue?')) {
        return
      }
      axios.patch(`/pbn/site/${pbn.punyDomain}`, {
        accessible: false
      })
        .then(r => {
          this.getPbns()
          $('#add-placement').modal('hide')
        })
    },
    async adminLogin () {
      let url = await axios.post(`/pbn/site/${this.pbn.punyDomain}/sso/session`)
      window.open(`${url.data.url}`, '_blank')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/Links/Order/Tabs/Build.vue